'use client'

import { createContext, useContext } from 'react'

import { VariantContextValuesType } from '../types'

export const PDPPageVariantContext = createContext<VariantContextValuesType | undefined>(undefined)

export function usePDPPageVariantContextValues(): VariantContextValuesType {
    const context = useContext(PDPPageVariantContext)
    if (context === undefined) {
        throw new Error('usePDPPageVariantContext must be used within a PDPPageVariantProvider')
    }
    return context
}
